// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__268Tc","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3gxzG","obliqueLine":"membershipbadge_obliqueLine__ea2Gp"};